import React from 'react'
import { submitLead, toReferralPayload } from '../api/leadGeneration'
import { getSessionId } from '../lib/session'
import { getUtmParams } from '../lib/utm'
import PublicPage from './PublicPage'

function submitReferral(page, form, values) {
  const interests = [...form.querySelectorAll('.look-chip[aria-pressed="true"]')].map((chip) =>
    chip.textContent.trim(),
  )
  const hasChips = form.querySelector('.look-chip') !== null
  if (hasChips && interests.length === 0) {
    return Promise.reject(new Error("Pick at least one option for what they're looking for."))
  }

  return submitLead(page.publicKey, {
    ...toReferralPayload(values, interests),
    sessionId: getSessionId(),
    ...getUtmParams(),
  })
}

function ReferralsPage() {
  return <PublicPage onFormSubmit={submitReferral} />
}

export default ReferralsPage
